import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractComponent } from '../abstract-component';
import { EncounterAttendenceService } from 'src/app/modules/provider-management/services/encounter-attendence.service';
import { takeUntil } from 'rxjs/operators';
import { IEncounterProviderDetails } from '../../interfaces/encounter-provider-details';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { LoadingService } from 'src/app/services/loading.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { timer } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-encounter-provider-details',
  templateUrl: './encounter-provider-details.component.html',
  styleUrls: ['./encounter-provider-details.component.scss'],
  standalone: false,
})
export class EncounterProviderDetailsComponent
  extends AbstractComponent
  implements OnInit
{
  public providerSk: string;
  public serviceTypeId: number;
  public providerDetails: IEncounterProviderDetails;
  public copyIcon: SVGIcon = this.customFaIcon(faCopy as IconDefinition);
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;
  public tooltipText: string = 'Copy ID';
  readonly tooltipResetDelayMS: number = 3000;

  constructor(
    private encounterAttendenceService: EncounterAttendenceService,
    private laodingService: LoadingService,
    private clipboard: Clipboard
  ) {
    super();
  }
  ngOnInit(): void {
    this.laodingService.show();
    this.getDetails();
  }
  afterOnDestroy(): void {
    // No additional cleanup needed
  }

  getDetails(): void {
    // Implementation for fetching provider details
    this.encounterAttendenceService
      .getProviderDetails(this.providerSk, this.serviceTypeId)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data: IEncounterProviderDetails) => {
        this.laodingService.hide();
        this.providerDetails = data;
      });
  }
  customFaIcon(icon: IconDefinition): SVGIcon {
    return {
      name: icon.iconName,
      content: `<path d="${icon.icon[4]}" />`,
      viewBox: `0 0 ${icon.icon[0]} ${icon.icon[1]}`,
    };
  }

  copyClipboard(copiedText: string): void {
    this.clipboard.copy(copiedText);
    this.tooltipText = 'Copied';
    timer(this.tooltipResetDelayMS)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(() => {
        this.tooltipText = 'Copy ID';
        this.tooltipDir?.hide();
      });
  }
}
